import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import LoadingIcon from '../site-render/src/icons/LoadingIcon';

function FullscreenLoading({ classes }) {
  return (
    <div className={classes.root}>
      <div className={classes.overlay} />
      <LoadingIcon />
    </div>
  );
}

FullscreenLoading.propTypes = {
  classes: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    left: 0,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1600,
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: theme.palette.common.lightBlack,
    animation: `overlayIn ${theme.transitions.duration.short}ms`,
  },
});

export default injectSheet(stylesheet)(FullscreenLoading);



// WEBPACK FOOTER //
// ./src/register/FullScreenLoading.js